import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAppDispatch } from "./store.hooks";
import { updateParams } from "../Common/Slices/ParamSlice";

const HistoryListener = (props: any) => {
  const dispatch = useAppDispatch();
  const location = useLocation();

  useEffect(() => {
    if (location.state != null) {
      dispatch(updateParams(location.state));
    }
  }, [location, dispatch]);

  return <div>{props.children}</div>;
};

export default HistoryListener;
